import type { FlightIngredient } from '@apps/main/modules/recipe/ingredients';

import type { IngredientSerializer } from '../..';

import { serializeFlight } from './serialize';
import { deserializeFlight } from './deserialize';

export const FlightSerializer: IngredientSerializer<FlightIngredient> = {
  serialize: (flight: FlightIngredient): string => serializeFlight(flight),
  deserialize: (value: string): FlightIngredient => deserializeFlight(value),
};

export { FLIGHT_INGREDIENT_SUFFIX } from './constants';
